import type { SelfOwnedWidgetDefinition } from '../WidgetDefinition';
import { faChartLine } from '@fortawesome/pro-duotone-svg-icons/faChartLine';
import type { TradingViewChartWidgetModel } from 'src/models/TradingViewChartWidgetModel';
import { TradingViewChartWidgetModelImpl } from 'src/models/TradingViewChartWidgetModel/impl';
import type { TradingViewChartWidgetState } from 'src/models/TradingViewChartWidgetModel/state';

class TradingViewChartWidgetDefinition implements SelfOwnedWidgetDefinition<
    TradingViewChartWidgetState,
    TradingViewChartWidgetModel
> {
    type = 'tradingview-chart' as const;
    nameKey = 'widgets::tradingview-chart::name' as const;
    roles = ['widgets::tradingview-chart'];
    icon = faChartLine;
    category = 'widgets::categories::research' as const;
    defaultDimensions = { h: 0.5, w: 0.6, x: 0.2, y: 0.25 };
    widgetClass = TradingViewChartWidgetModelImpl;
}

export const tradingViewChartWidgetDefinition = new TradingViewChartWidgetDefinition();
